// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as PnMRepo$PorterinFeature from "./PnMRepo.mjs";
import * as Environments$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/Environments.mjs";
import * as LocaleHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as DummyPnMRepo$PorterinFeature from "./DummyPnMRepo.mjs";

function getRepo(param) {
  if (Config$PorterinUtils.env === Environments$PorterinUtils.development || LocaleHelpers$PorterinUtils.isPageEnabledForLocaleIntPnM(undefined)) {
    return {
            validateGeoregion: DummyPnMRepo$PorterinFeature.validateGeoregion,
            createPnMOrderInterest: DummyPnMRepo$PorterinFeature.createPnMOrderInterest,
            submitPnMShiftReqBasicDetails: DummyPnMRepo$PorterinFeature.submitPnMShiftReqBasicDetails,
            getPaths: DummyPnMRepo$PorterinFeature.getPaths,
            getPageContent: DummyPnMRepo$PorterinFeature.getPageContent,
            submitPnMShiftReqLocationDetails: DummyPnMRepo$PorterinFeature.submitPnMShiftReqLocationDetails
          };
  } else {
    return {
            validateGeoregion: PnMRepo$PorterinFeature.validateGeoregion,
            createPnMOrderInterest: PnMRepo$PorterinFeature.createPnMOrderInterest,
            submitPnMShiftReqBasicDetails: PnMRepo$PorterinFeature.submitPnMShiftReqBasicDetails,
            getPaths: PnMRepo$PorterinFeature.getPaths,
            getPageContent: PnMRepo$PorterinFeature.getPageContent,
            submitPnMShiftReqLocationDetails: PnMRepo$PorterinFeature.submitPnMShiftReqLocationDetails
          };
  }
}

export {
  getRepo ,
}
/* Config-PorterinUtils Not a pure module */
